import Vue from 'vue'

/** 全局登录遮罩：不跳转 /login，在当前页弹窗 */
export const loginGate = Vue.observable({
  visible: false
})

export function hasAuthToken() {
  return !!(localStorage.getItem('token') || sessionStorage.getItem('token'))
}

/** 已登录用户（排除游客 guest_token） */
export function isLoggedInUser() {
  const token = String(localStorage.getItem('token') || sessionStorage.getItem('token') || '').trim()
  if (!token) return false
  if (token.startsWith('guest_token')) return false
  return true
}

export function openLoginModal() {
  loginGate.visible = true
}

export function closeLoginModal() {
  loginGate.visible = false
}

/** 清除登录态并打开登录弹窗 */
export function logoutUser() {
  localStorage.removeItem('token')
  sessionStorage.removeItem('token')
  closeLoginModal()
  openLoginModal()
}
